import Service from '@/helpers/service'

export default {
	get(params) {
		return Service().get('KpiMcrCreation', {params});
	}
}
